module.exports = {
    EMAIL_KEY: 'mtv_auth_email',
    AUTH_KEY_TW: 'auth_tw',
    KEY_PREFIX: 'mtva2023',
    USER: 'auth_user'
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_storage.js